import type { Network } from '@mogul/api-client';
import { UnlockableContentType } from '@mogul/api-client';
import { resolveSigningMessage, SignType } from '@mogul/shared';
import { signMessage } from '@wagmi/core';

import { collectionsApi, nftsApi } from '../api';

export const collectionHasUnlockableContent = async (
  tokenAddress: string,
  tokenId: string,
) => {
  try {
    const unlockableContentNftBoolean = await nftsApi.hasNftUnlockableContent({
      contractAddress: tokenAddress,
      id: tokenId,
    });

    const unlockableContentCollectionBoolean =
      await collectionsApi.hasUnlockableContent({
        contractAddress: tokenAddress,
      });
    return (
      unlockableContentCollectionBoolean.data.data.valueOf() ||
      unlockableContentNftBoolean.data.data.valueOf()
    );
  } catch (e) {
    return false;
  }
};

export const getUnlockableContent = async (
  nftContractAddress: string,
  nftId: string,
  address: string,
  hashedMessage: string,
  currentNetwork: Network,
) => {
  let content = '';
  let type = UnlockableContentType.Markdown;

  try {
    const unlockableNftContent = await nftsApi.getNftUnlockableContentIfValid({
      nftContractAddress,
      nftId,
      address,
      hashedMessage,
      network: currentNetwork,
    });
    const unlockableCollectionContent =
      await collectionsApi.getUnlockableContentIfValid({
        nftContractAddress,
        nftId,
        address,
        hashedMessage,
        network: currentNetwork,
      });

    if (unlockableNftContent.data.data !== null) {
      content = unlockableNftContent.data.data;
      type = unlockableNftContent.data.type;
    } else if (unlockableCollectionContent.data.data !== '') {
      content = unlockableCollectionContent.data.data;
      type = unlockableCollectionContent.data.type;
    }

    return { content, type };
  } catch (e) {
    return { content, type };
  }
};

export const checkIfValidSignedMessage = async (address: string) => {
  try {
    const hashedMessage = await signMessage({
      message: resolveSigningMessage(SignType.unlockContent),
    });
    const res = await nftsApi.verifySignedMessage({
      hashedMessage,
      address,
    });

    return { state: res.data, hash: hashedMessage };
  } catch (error) {
    console.error(error);
  }
};
